module.exports = __webpack_public_path__ + "img/banner-my.f62508f2.png";